import { GUID } from '../../helpers/guid.helper';

export class Payment {
    Id: string;
    Date: Date;
    Amount: number;
    IsActive: boolean;
    PaymentConceptId: number;
    Observation: string;
    ReceiptNumber: string;

    constructor(){
        this.Id = GUID.newGuid();
        this.Date = new Date();
        this.Amount = undefined;
        this.IsActive = true;
        this.PaymentConceptId = undefined;
        this.Observation = undefined;
        this.ReceiptNumber = undefined;
    }
}



// WEBPACK FOOTER //
// ./src/app/main/models/payment/payment.ts